<template>
  <section
    data-component="VCard"
    class="rounded-lg bg-white px-[var(--card-padding-x,1.5rem)] py-[var(--card-padding-y,1.25rem)] [box-shadow:var(--shadow-ring),var(--shadow-elevation)]"
  >
    <slot />
  </section>
</template>
